import { useEffect } from "react";

/**
 * Freezes page scrolling while a dialog is open without losing the reader's place.
 * Pins the body at its current offset, then restores that exact position on close.
 */
export function useScrollLock(active = true) {
  useEffect(() => {
    if (!active) return;
    const y = window.scrollY;
    const body = document.body;
    const prev = {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
    };
    body.style.position = "fixed";
    body.style.top = `-${y}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";

    return () => {
      Object.assign(body.style, prev);
      window.scrollTo({ top: y, left: 0, behavior: "instant" as ScrollBehavior });
    };
  }, [active]);
}
